// test2142
(2142 && 0);
